import messages from '~/constants/localizations/teamStats';

export const MLB_BATTING = [
  {
    key: 'batting_average',
    meta_key: 'batting_average_rank',
    label: 'AVG',
    localized_label: messages.baseball.batting_average,
  },
  {
    key: 'on_base_percentage',
    meta_key: 'batting_average_rank',
    label: 'OBP',
    localized_label: messages.baseball.on_base_percentage,
  },
  {
    key: 'slugging_percentage',
    meta_key: 'slugging_percentage_rank',
    label: 'SLG',
    localized_label: messages.baseball.slugging_percentage,
  },
  {
    key: 'on_base_plus_slugging',
    meta_key: 'on_base_plus_slugging_rank',
    label: 'OPS',
    localized_label: messages.baseball.slugging_percentage,
  },
  {
    key: 'home_runs',
    meta_key: 'home_runs_rank',
    label: 'HR',
    localized_label: messages.baseball.home_runs,
  },
  {
    key: 'stolen_bases',
    meta_key: 'stolen_bases_rank',
    label: 'SB',
    localized_label: messages.baseball.stolen_bases,
  },
];

export const MLB_PITCHING = [
  {
    key: 'formatted_earned_run_average',
    meta_key: 'earned_run_average_rank',
    label: 'ERA',
    localized_label: messages.baseball.earned_run_average,
  },
  {
    key: 'formatted_walks_plus_hits_per_inning_pitched',
    meta_key: 'walks_plus_hits_per_inning_pitched_rank',
    label: 'WHIP',
    localized_label: messages.baseball.walks_plus_hits_per_inning_pitched,
  },
  {
    key: 'formatted_strikeouts_per_9_innings_pitched',
    meta_key: 'strikeouts_per_9_innings_pitched_rank',
    label: 'K/9',
    localized_label: messages.baseball.strikeouts_per_9_innings_pitched,
  },
  {
    key: 'home_runs_against',
    meta_key: 'home_runs_against_rank',
    label: 'HR',
    localized_label: messages.baseball.home_runs,
  },
  {
    key: 'formatted_fielding_percentage',
    meta_key: 'fielding_percentage_rank',
    label: 'FLD%',
    localized_label: messages.baseball.fielding_percentage,
  },
  {
    key: 'formatted_batting_average_against',
    meta_key: 'batting_average_against_rank',
    label: 'BAA',
    localized_label: messages.baseball.batting_average_against,
  },
];

export const MLB_OVERVIEW = [
  {
    key: 'runs_per_game',
    meta_key: 'runs_per_game_rank',
    label: 'Runs',
    localized_label: messages.baseball.runs_per_game,
  },
  {
    key: 'runs_against_per_game',
    meta_key: 'runs_against_per_game_rank',
    label: 'Runs Allowed',
    localized_label: messages.baseball.runs_against_per_game,
  },
  {
    key: 'hits_per_game',
    meta_key: 'hits_per_game_rank',
    label: 'Hits',
    localized_label: messages.baseball.hits_per_game,
  },
  {
    key: 'hits_against_per_game',
    meta_key: 'hits_against_per_game_rank',
    label: 'Hits Allowed',
    localized_label: messages.baseball.hits_against_per_game,
  },
];
